import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
// import { number, bool, func } from 'prop-types'

import Facebook from './assets/facebook.svg'
import Facebooka from './assets/facebook-a.svg'
import Instagram from './assets/instagram.svg'
import Instagrama from './assets/instagram-a.png'
import Twitter from './assets/twitter.svg'
import Twittera from './assets/twitter-a.svg'
import Linkedin from './assets/linkedin.svg'
import Linkedina from './assets/linkedin-a.svg'

import SectionPopUp from '../../common/Modals/SectionPopUp'

import './AppFooter.scss'

const AppFooter = () => (
  <div className='app__footer'>
    <div className='container'>
      <div className='row'>
        <div className='rl-cl-l-7 rl-cl-m-7 rl-cl-xs-12'>
          <div className='row'>
            <div className='rl-cl-l-3 rl-cl-m-3 rl-cl-s-4 rl-cl-xs-12 borBottom'>
              <h6 className='footer__title'>Minapoli</h6>
              <ul className='list-unstyled'>
                <li><Link to='/about'>Tentang Kami</Link></li>
                <li><Link to=''>Pusat Bantuan</Link></li>
                <li><Link to=''>Kebijakan Privasi</Link></li>
                <li><Link to=''>Syarat & Ketentuan</Link></li>
                <li><Link to='/i/join-our-team'>Karir</Link></li>
              </ul>
            </div>
            <div className='rl-cl-l-4 rl-cl-m-4 rl-cl-s-4 rl-cl-xs-12 borBottom'>
              <h6 className='footer__title'>Customer Care</h6>
              <ul className='list-unstyled'>
                <li><p>E : halo@minapoli.com</p></li>
                <li><p>T : +62 811 1138 168</p></li>
                <li><p>Jam Operasional</p></li>
                <li><p>08.00 - 18.00 WIB</p></li>
              </ul>
            </div>
            <div className='rl-cl-l-5 rl-cl-m-5 rl-cl-s-4 rl-cl-xs-12 borBottom'>
              <h6 className='footer__title'>Our Office</h6>
              <ul className='list-unstyled'>
                <li><p>PT. Inovasi Perikanan Nusantara</p></li>
                <li><p>DBS Bank Tower Lt. 28</p></li>
                <li><p>Ciputra World One</p></li>
                <li><p>Jl. Prof. Dr. Satrio Kav 3-5</p></li>
                <li><p>Jakarta Selatan 12940</p></li>
              </ul>
            </div>
          </div>
        </div>
        <div className='rl-cl-l-5 rl-cl-m-5 rl-cl-xs-12'>
          <div className='row clearfix'>
            <div className='rl-cl-l-5 rl-cl-xs-12 pull-right borBottom'>
              <h6 className='footer__title'>Follow us</h6>
              <ul className='social list-unstyled list-inline'>
                <li><a
                  href='https://www.facebook.com/minapoli.id'
                  target='_blank'
                  rel='noreferrer noopener'
                  className='social__media'><img src={Facebook} alt='' />
                  <div className='hover'><img src={Facebooka} alt='' /></div>
                </a></li>
                <li><a
                  href='https://www.instagram.com/minapoli.id'
                  target='_blank'
                  rel='noreferrer noopener'
                  className='social__media'><img src={Instagram} alt='' />
                  <div className='hover'><img src={Instagrama} alt='' /></div>
                </a></li>
                <li><a
                  href='https://www.twitter.com/minapoli_id'
                  target='_blank'
                  rel='noreferrer noopener'
                  className='social__media'><img src={Twitter} alt='' />
                  <div className='hover'><img src={Twittera} alt='' /></div>
                </a></li>
                <li><a
                  href='https://www.linkedin.com/company/13432157/'
                  target='_blank'
                  rel='noreferrer noopener'
                  className='social__media'><img src={Linkedin} alt='' />
                  <div className='hover'><img src={Linkedina} alt='' /></div>
                </a></li>
              </ul>
            </div>
            <div className='rl-cl-l-5 rl-cl-xs-12 pull-right borBottom'>
              <h6 className='footer__title'>Get in touch</h6>
              <SectionPopUp section='contactus'>
                <a className='call__us'>Hubungi Kami</a>
              </SectionPopUp>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className='copyright'>
      <div className='container'>
        <div className='row'>
          <div className='rl-cl-l-12'>
            <p>© 2018 Minapoli. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
)

AppFooter.propTypes = {
}

AppFooter.defaultProps = {
}

const mapStateToProps = () => ({
  //
})

const mapDispatchToProps = dispatch => bindActionCreators({
  //
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AppFooter)



// WEBPACK FOOTER //
// ./src/common/AppFooter/AppFooter.js